import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import RTPageLayout from '../common/RTPageLayout';
import '../common/rtCommon.css';
import '../common/Tile.css';

const tiles = [
  {
    icon: '🏢',
    title: 'Add Building',
    permissionKey: 'building.add',
    description: 'Add a new building to the system',
    url: 'add',
  },
  {
    icon: '📋',
    title: 'View Buildings',
    permissionKey: 'building.view',
    description: 'See all buildings and their details',
    url: 'list',
  },
];

const BuildingManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Building Management"
        mainSection
        activePath={location.pathname}
      >
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              icon={tile.icon}
              title={tile.title}
              description={tile.description}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default BuildingManagement;
